import { AddRounded } from "@mui/icons-material";
import { Button } from "@mui/material";
import { memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { loanDrilldownSidebarTypes } from "../../../constants/enums/loanDrilldownScreenSidebarOptions";
import {
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../redux/actions/sidebarActions";

const LoanDrilldownButtonAddBrokerTerm = memo(({ size = "small", sx }) => {
  const dispatch = useDispatch();

  const onAdd = useCallback(() => {
    dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_EDIT_BROKER_TERMS));
    dispatch(sidebarSetStateValue(null));
  }, [dispatch]);

  return (
    <Button size={size} sx={sx} startIcon={<AddRounded />} onClick={onAdd}>
      Add Broker Term
    </Button>
  );
});
export default LoanDrilldownButtonAddBrokerTerm;
